import React from 'react';
import { Row, Col, Typography } from 'antd';
import moment from 'moment';
import FareBreakdownCard from './FareBreakdownCard';

const { Title } = Typography;

const TravellerDetails = ({
    selectPayloadData,
    calculatedFee,
    finalTotal,
    flightDetails,
    convenienceCharge,
    applicableChargeData,
    setApplyDiscountShow,
    setDiscountAmountOffer,
    discountAmountOffer,
    applyDiscountShow,
    meelBaggegasData,
    mealTotalAmount,
    mealTotalAmountRetrun,
    totalAmount,
    totalAmountReturn,
}) => {
    const travellerInfo = selectPayloadData?.bookings?.[0]?.passengers || [];
    const getTagColor = (paxType) => {
        switch (paxType) {
            case 1:
                return 'blue';
            case 2:
                return 'orange';
            case 3:
                return 'green';
            default:
                return 'gray';
        }
    };


    return (
        <div className="booking-details lastBorder">
            <div title="" className="traveller-card">
                <Title level={5} className='mt-3 mt-0'>Review Details</Title>
                <p className='mb-3'>Please ensure that the spelling of your name and other details match with your travel document/govt. ID, as these cannot be changed later. Errors might lead to cancellation penalties.</p>
                <Row gutter={16} style={{ overflowY: 'auto', maxHeight: '420px', padding: '5px 0' }}>
                    {travellerInfo?.map((traveller, index) => (
                        <Col key={index} xs={24}>
                            <div className="card traveller-info-card">
                                <div className="card-header py-2">
                                    <h3 style={{ color: getTagColor(traveller.PaxType) }}>
                                        <b>{traveller.PaxType === 1 ? 'ADULT' : traveller.PaxType === 2 ? 'CHILD' : 'INFANT'}</b>
                                    </h3>
                                    <p>Traveller {index + 1}</p>
                                </div>
                                <div className="card-body">
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>Title:</span> <strong>{traveller?.Title || 'N/A'}</strong>
                                    </p>
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>First Name:</span> <strong>{traveller?.FirstName || 'N/A'}</strong>
                                    </p>
                                    <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                        <span>Last Name:</span> <strong>{traveller?.LastName || 'N/A'}</strong>
                                    </p>
                                    {traveller?.DateOfBirth && (
                                        <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                            <span>Date of Birth:</span> <strong>  {moment(traveller?.DateOfBirth).format("MMM DD, YYYY")}</strong>
                                        </p>
                                    )}
                                    {traveller?.PassportNo && (
                                        <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                            <span>Passport Number:</span> <strong>{traveller?.PassportNo}</strong>
                                        </p>
                                    )}
                                    {traveller?.PassportExpiry
                                        && (
                                            <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                                <span>Passport Expiry Date   :</span> <strong>  {moment(traveller?.PassportExpiry).format("MMM DD, YYYY")}</strong>
                                            </p>
                                        )}
                                    {traveller?.CountryName && (
                                        <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                            <span>Nationality:</span> <strong>{traveller?.CountryName || 'N/A'}</strong>
                                        </p>
                                    )}
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
            {(

                Object.keys(meelBaggegasData?.Flight?.mealsDynamic || {}).length > 0 ||
                Object.keys(meelBaggegasData?.Flight?.baggageDynamic || {}).length > 0 ||
                Object.keys(meelBaggegasData?.Flight?.seatDynamic || {}).length > 0
            ) ? null : <FareBreakdownCard
                flightDetails={flightDetails}
                convenienceCharge={convenienceCharge}
                calculatedFee={calculatedFee}
                applyDiscountShow={applyDiscountShow}
                discountAmountOffer={discountAmountOffer}
                finalTotal={finalTotal}
                mealTotalAmount={mealTotalAmount}
                mealTotalAmountRetrun={mealTotalAmountRetrun}
                totalAmount={totalAmount}
                totalAmountReturn={totalAmountReturn}
            />}

        </div>
    );
};

export default TravellerDetails;
